'use client';

import { useTranslation } from 'react-i18next';

import { ACHAccountNumber } from '@sola/ark-core/molecules/ach-fields/ach-account-number.js';
import { ACHName } from '@sola/ark-core/molecules/ach-fields/ach-name.js';
import { ACHRoutingNumber } from '@sola/ark-core/molecules/ach-fields/ach-routing-number.js';
import { InputField } from '@sola/ark-core/molecules/input-field/input-field.js';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@sola/ark-core/molecules/tooltip/tooltip.js';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.js';
import { SupporterAchFieldsEnum } from '@sola/schema/dotcom/supporters/paymentMethods.js';

export const PaymentACHFields = () => {
  const { t } = useTranslation('my');

  return (
    <>
      <ACHAccountNumber name={SupporterAchFieldsEnum.accountNumber} required />

      <ACHRoutingNumber name={SupporterAchFieldsEnum.routingNumber} required />

      <div
        className="flex flex-row label-moderate label-md"
        style={{
          color: 'var(--color-action-foreground-moderate)',
        }}
      >
        <Tooltip>
          <TooltipTrigger>
            <button
              type="button"
              className="flex justify-center items-center gap-snug-md"
            >
              {t('paymentMethods.ach.description')}
              <ArkIcon iconName="help-circle" height="20px" width="20px" />
            </button>
          </TooltipTrigger>
          <TooltipContent size="sm" align="start" alignOffset={0}>
            <p>
              <strong>
                {t('paymentMethods.ach.information.routing.label')}
                {': '}
              </strong>
              {t('paymentMethods.ach.information.routing.body')}
            </p>
            <p>
              <strong>
                {t('paymentMethods.ach.information.checking.label')}
                {': '}
              </strong>
              {t('paymentMethods.ach.information.checking.body')}
            </p>
          </TooltipContent>
        </Tooltip>
      </div>

      <ACHName name={SupporterAchFieldsEnum.accountName} required />

      <InputField
        name={SupporterAchFieldsEnum.nickname}
        label={t('addPaymentMethod.form.fields.achNickName')}
        hint={t('addPaymentMethod.form.optional')}
      />
    </>
  );
};
